<template>
  <div v-if="getAllowGiftPurchases">
    <BtnBaseBlue
      @click="revealDialog"
      :outlined="!getIsGift"
      block
      :disabled="getPlacingOrder"
      :large="_includes(['xs', 'sm'], $mq)"
      class="mt-2"
      >{{ getIsGift ? 'Edit Gift Details' : 'Make this a Gift'
      }}<v-icon right>mdi-gift</v-icon></BtnBaseBlue
    >
    <v-dialog
      :value="showDialog"
      width="400"
      scrollable
      persistent
      :fullscreen="$mq === 'xs'"
    >
      <v-card :tile="$mq === 'xs'">
        <v-card-title class="blue darken-2 white--text">
          <h2 class="text-h4 mb-1 mx-auto">
            Gift Recipient Details
          </h2>
        </v-card-title>
        <v-card-text class="pt-6 pb-8">
          <v-form v-model="isFormValid">
            <v-text-field
              autofocus
              :rules="[requiredString]"
              v-model="first_name"
              label="First Name"
            />
            <v-text-field
              :rules="[requiredString]"
              v-model="last_name"
              label="Last Name"
            />
            <v-text-field
              :rules="[requiredString, emailRule]"
              v-model="email"
              label="Email"
            />
            <v-text-field
              :rules="[requiredString, phoneRule]"
              v-model="phone"
              label="Phone"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <BtnBaseBlue
            @click="setNotGift"
            depressed
            class="white--text"
            color="blue darken-2"
            large
            outlined
            >Not a gift</BtnBaseBlue
          >
          <v-spacer />
          <BtnBaseBlue
            @click="showDialog = false"
            depressed
            class="white--text"
            color="blue darken-2"
            :disabled="!isFormValid"
            large
            >Save</BtnBaseBlue
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _includes from 'lodash/includes'
import BtnBaseBlue from '@/components/BtnBaseBlue'
import Rules from '@/constants/ValidationRules'

export default {
  name: 'CheckoutGiftDetails',
  components: { BtnBaseBlue },
  data() {
    return {
      email: '',
      first_name: '',
      last_name: '',
      phone: '',
      showDialog: false,
      isFormValid: true,
      requiredString: Rules.requiredString,
      emailRule: Rules.emailRule,
      phoneRule: Rules.phoneRule,
    }
  },
  computed: {
    ...mapGetters('shop', ['getAllowGiftPurchases']),
    ...mapGetters('cart', [
      'getPlacingOrder',
      'getGifteeDetails',
      'getIsGift',
      'isDelivery',
    ]),
    concattedDetails() {
      let details = [this.first_name, this.last_name, this.email, this.phone]
        .filter((i) => i.trim().length)
        .join(' | ')
      return details
    },
    recipientDetails: {
      get() {
        return this.getGifteeDetails
      },
      set(details) {
        this.setGifteeDetails(details)
      },
    },
  },
  methods: {
    ...mapActions('cart', ['setGifteeDetails', 'setIsGiftVal']),
    revealDialog() {
      this.setIsGiftVal(true)
      this.showDialog = true
    },
    setNotGift() {
      this.setIsGiftVal(false)
      this.showDialog = false
    }, // setNotGift
    _includes,
  },
  watch: {
    concattedDetails() {
      let { email, first_name, last_name, phone } = this
      this.recipientDetails = {
        email,
        first_name,
        last_name,
        phone,
      }
    },
  },
}
</script>
